import { useEffect, useMemo, useState, useCallback } from 'react';
import { Account } from '../types';
import { WorkloadClient } from '@internal/workload-api-helper';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useAccountId } from './useAccountId';

export const useWorkload = (): {
  workload: Account | undefined;
  loading: boolean;
} => {
  const accountId = useAccountId();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const workloadClient = useMemo(() => {
    return new WorkloadClient(configApi, oauthApi);
  }, [configApi, oauthApi]);
  const [workload, setWorkload] = useState<Account | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true); // Added loading state

  const fetchWorkload = useCallback(async () => {
    setLoading(true); // Set loading to true before fetching
    try {
      const response = await workloadClient.apiFetch(`workloads/${accountId}`);
      const result: Account = await response.json();
      setWorkload(result);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  }, [workloadClient, accountId]);

  useEffect(() => {
    fetchWorkload();
  }, [fetchWorkload]);

  return { workload, loading }; // Return loading state along with workload
};
